import { render, staticRenderFns } from "./PolicyTypesSelect.vue?vue&type=template&id=13e204ab&scoped=true"
import script from "./PolicyTypesSelect.vue?vue&type=script&lang=js"
export * from "./PolicyTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e204ab",
  null
  
)

export default component.exports